import React from 'react';
import { PaperClipIcon } from '@heroicons/react/24/outline';
import tw, { TwStyle } from 'twin.macro';
import Tooltip2 from '@teetsh/app/src/components/Tooltip2';
import { PreviewImg } from '@teetsh/app/src/components/Attachments/PreviewImg';
import { isURLAnImage } from '@teetsh/app/src/components/Attachments/isUrlImage';
import { Attachment } from '@teetsh/app/src/types/attachment';
import { getSeanceAttachmentUrl } from '@teetsh/app/src/utils/urls';

interface Props {
  noColor?: boolean;
  attachment: Attachment;
  preview?: boolean;
  largeIcon?: boolean;
  iconStyle?: TwStyle;
  linkStyle?: TwStyle;
}

export default function AttachmentLink(props: Props) {
  const { attachment, noColor, preview } = props;
  const downloadUrl = getSeanceAttachmentUrl(
    attachment.s3Path,
    attachment.s3Filename,
    attachment.label,
  );
  const Component = (
    <div tw="flex text-sm items-center">
      <PaperClipIcon
        css={[
          props.largeIcon && tw`h-5 w-5`,
          !props.largeIcon && tw`h-4 w-4`,
          tw` mr-1 shrink-0`,
          props.iconStyle,
        ]}
      />
      <a
        onClick={e => e.stopPropagation()}
        href={downloadUrl}
        rel="noreferrer noopener"
        css={[
          tw`ml-1 text-primary hover:underline break-all`,
          noColor && tw`text-neutral-intense`,
          props.linkStyle,
        ]}
        target="_blank"
      >
        {attachment.label}
      </a>
    </div>
  );
  if (isURLAnImage(downloadUrl) && preview) {
    return (
      <Tooltip2
        label={
          <PreviewImg
            alt={attachment.label}
            fileUrl={downloadUrl}
            maxHeight="250px"
            maxWidth="250px"
          />
        }
      >
        {Component}
      </Tooltip2>
    );
  }
  return Component;
}
